import { Map, List, fromJS } from 'immutable'

/**
 * List
 */

export function productsLoading(state = false, action) {
  switch (action.type) {
    case 'PRODUCTS_FETCH_LOADING':
      return action.isLoading
    case 'PRODUCTS_FETCH_SUCCESS':
    case 'PRODUCTS_FETCH_ERROR':
      return false
    default:
      return state
  }
}

export function productsError(state = false, action) {
  switch (action.type) {
    case 'PRODUCTS_FETCH_ERROR':
      return action.hasErrored
    default:
      return state
  }
}

export function products(state = false, action) {
  switch (action.type) {
    case 'PRODUCTS_FETCH_SUCCESS':
      return fromJS(action.items || [])
    case 'PRODUCT_CREATE_SUCCESS':
      return List.isList(state) ? state.push(fromJS(action.item)) : state
    case 'PRODUCT_UPDATE_SUCCESS':
      return !List.isList(state)
        ? state
        : state.map(org => (org.get('id') === action.item.id ? fromJS(action.item) : org))
    default:
      return state
  }
}
